<template>
  <v-app>
    <SuccessPayment v-if="success" :info="data"></SuccessPayment>
    <FailedPayment v-if="failed" :info="data"></FailedPayment>
  </v-app>
</template>
<script>
import SuccessPayment from "@/view/pages/payment-callback/SuccessPayment";
import FailedPayment from "@/view/pages/payment-callback/FailedPayment";

export default {
  components: {FailedPayment, SuccessPayment},
  data() {
    return {
      data: null,
      success: false,
      failed: false
    }
  },
  mounted() {
    console.log(this.$route.query.Authority);
    this.checkPayment();
  },
  methods: {
    checkPayment() {
      this.requestApiPost('transactioncallback', {
        Authority: this.$route.query.Authority,
        Status: this.$route.query.Status,
      }).then(({data}) => {
        this.data = data;
        this.$router.replace({'query': null});
        this.success = true;
      }).catch(({response}) => {
        this.data = response.data;
        this.$router.replace({'query': null});
        this.failed = true;
      });

      if (!this.$route.query.Status) {
        return this.$router.push({name: 'dashboard'});
      }
    }
  }

}
</script>